import { ref, Ref } from "vue";
import { useToast } from "vue-toast-notification";

export interface UseFileUploadReturn {
  file: Ref<File | null>;
  previewUrl: Ref<string>;
  handleFileChange: (
    files: FileList,
    fileRef: Ref<File | null>,
    targetPreviewRef?: Ref<string>
  ) => void;
  handleRemoveFile: (
    fileRef?: Ref<File | null>,
    targetPreviewRef?: Ref<string>
  ) => void;
}

const useFileUpload = (maxSizeMB: number = 5): UseFileUploadReturn => {
  const file = ref<File | null>(null);
  const previewUrl = ref<string>("");
  
  const toast = useToast();

  const handleFileChange = (
    files: FileList,
    fileRef: Ref<File | null>,
    targetPreviewRef?: Ref<string>
  ) => {
    if (!files.length) return;

    const selectedFile = files[0];

    if(selectedFile.size > maxSizeMB * 1024 * 1024) {
      toast.error(`File is too large. Please select an image under ${maxSizeMB}MB.`, {
        position: "top-right",
      });
      return;
    }

    fileRef.value = selectedFile;

    const reader = new FileReader();
    reader.onload = (e) => {
      const result = e.target?.result as string;

      if (targetPreviewRef) {
        targetPreviewRef.value = result;
      } else {
        previewUrl.value = result;
      }
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleRemoveFile = (
    fileRef?: Ref<File | null>,
    targetPreviewRef?: Ref<string>
  ) => {
    file.value = null;
    previewUrl.value = "";
    if (fileRef) fileRef.value = null;
    if (targetPreviewRef) targetPreviewRef.value = "";
  };

  return {
    file,
    previewUrl,
    handleFileChange,
    handleRemoveFile
  };
};

export default useFileUpload;